<template>
  <div>
    <b-navbar toggleable="lg" type="dark"  v-if="is_logged()">
      <b-navbar-brand href="#"><img :src="api('static/img/logos/shoelabel.svg')" height="15px"/></b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/vote">etykietuj</b-nav-item>
          <b-nav-item to="/history/0">historia</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav v-if="auth!==null && auth.user!==null && auth.user.role==='ADMIN'">
          <b-nav-item to="/users">użytkownicy</b-nav-item>
          <b-nav-item to="/pairs">pary</b-nav-item>
          <b-nav-item to="/stats">statystyki</b-nav-item>
          <b-nav-item to="/job">zleć</b-nav-item>
          <b-nav-item to="/etl">dodaj</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">


          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content v-if="auth.user!==null">
              <img :src="api('static/img/logos/acc.svg')" height="20px" /> &nbsp;<em>{{ auth.user.login }}</em>
            </template>
            <b-dropdown-item @click="logOut()">wyloguj</b-dropdown-item>

          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div style="min-height: 500px">
      <router-view @login_success="logIn" :axios="axios"></router-view>
    </div>
    <div class="footer">
      <b-row align-h="between">
        <b-col cols="auto">
          <img :src="api('static/img/logos/ir2.svg')" height="50px">
        </b-col>
        <b-col cols="auto">
          <img :src="api('static/img/logos/rp2.svg')" height="50px">
        </b-col>
        <b-col cols="auto">
          <a href="www.ncbr.gov.pl">
            <img :src="api('static/img/logos/ncbr2.svg')" height="50px">
          </a>
        </b-col>
        <b-col cols="auto">
          <img :src="api('static/img/logos/efrr2.svg')" height="50px">
        </b-col>
        <b-col cols="auto">
          <img :src="api('static/img/logos/opi.svg')" height="50px">
        </b-col>
      </b-row>
    </div>
  </div>


</template>

<script>

// region imports
import {api} from './utils'
import axios from 'axios';
// endregion imports


export default {
  name: 'App',
  data: function () {
    return {
      axios: axios.create({}),
      auth: {
        token: null,
        user: null
      },
    }
  },
  methods: {
    is_logged() {
      return this.auth.token !== null;
    },
    set_token(token) {
      this.auth.token = token;
      if (token !== null) {
        localStorage.setItem("token", token);
        this.axios.defaults.headers["Authorization"] = `Bearer ${token}`;
        this.axios.get(api("me")).then(resp => this.auth.user = resp.data);
      } else {
        localStorage.removeItem("token");
        delete this.axios.defaults.headers["Authorization"];
        this.auth.user = null;
      }
    },
    logOut() {
      this.set_token(null)
      this.$router.push("/login")
    },
    logIn(token) {
      this.set_token(token)
      this.$router.push("/vote")
    },
    api(url) {
      return api(url)
    }
  },
  created: function () {
    this.set_token(localStorage.getItem("token"));
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.role === "ADMIN" && (this.auth.token === null || this.auth.user.role !== "ADMIN"))
        next("/login")
      else if (to.meta.role === "USER" && this.auth.token === null)
        next("/login")
      else if ((to.path === "/login" || to.path === "/") && this.auth.token !== null)
        next("/vote")
      else
        next()
    })
  },

  components: {}
  // {
  //   LoginRegister, Users, Pairs,
  //   // Voting, History,
  //   QuadVoting, QuadHistory, Quads
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.menu_item {
  margin-right: 20px;
  margin-left: 20px;
}

.router-link-active, .router-link-exact-active {
  color: white !important;
}

.footer{
  padding:2em;
}

</style>
